import React from "react";
import {
  FaChartLine,
  FaCogs,
  FaCoins,
  FaExchangeAlt,
  FaPalette,
  FaWater,
} from "react-icons/fa";

function StunningFeatures() {
  return (
    <>
      <div
        className="process-style-three-area default-padding bg-dark text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
        }}
      >
        <div className="shape">
          <img
            src="https://validthemes.net/site-template/robok/assets/img/illustration/16.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">How it works</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Stunning Features of Xeer Technology’s AMM DEX
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-2">
              <div className="process-style-three-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaWater size={40} />
                  </div>
                  <h4>Liquidity Pools for Efficient Market Making</h4>
                  <p>
                    Our AMM DEX platforms leverage liquidity pools, allowing
                    users to contribute assets to the pool in exchange for
                    rewards, creating continuous liquidity for seamless,
                    low-slippage trading.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaCogs size={40} />
                  </div>
                  <h4>Automated Pricing Mechanisms</h4>
                  <p>
                    Our AMMs use automated pricing algorithms (e.g., Constant
                    Product Formula) that adjust prices based on supply and
                    demand, providing fair and transparent pricing without
                    intermediaries.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaCoins size={40} />
                  </div>
                  <h4>Yield Farming and Staking</h4>
                  <p>
                    We offer integrated yield farming and staking options,
                    enabling liquidity providers to earn additional rewards and
                    enhancing your platform’s attractiveness for DeFi users
                    seeking passive income.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="col-lg-10 offset-lg-2">
              <div className="process-style-three-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaExchangeAlt size={40} />
                  </div>
                  <h4>Cross-Chain Compatibility</h4>
                  <p>
                    Xeer Technology’s AMM DEXs can operate across multiple
                    blockchain networks like Ethereum, BNB Chain, and Polygon,
                    allowing users to trade assets from various ecosystems
                    within one platform.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaPalette size={40} />
                  </div>
                  <h4>Intuitive and Customizable User Interface</h4>
                  <p>
                    Our AMM DEX platforms are designed for ease of use, with a
                    sleek and customizable UI that simplifies the trading and
                    liquidity provision experience for all users.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaChartLine size={40} />
                  </div>
                  <h4>Real-Time Data and Analytics</h4>
                  <p>
                    Integrated analytics tools allow users to view pool
                    performance, volume, and real-time price data, enabling them
                    to make informed trading decisions and track market trends.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StunningFeatures;
